// The workflows page and its table.
export default {
  newWorkflow: "New workflow",
  filterByStatus: "Filter by status",
  search: "Search workflows",
  taskType: "Task type",
  allTaskTypes: "All task types",
  loadError: "Could not load the workflows",
  emptyTitle: "No workflows yet",
  emptyBody: "A workflow is a graph of prompts, branches and approvals. Create one, build its graph and publish it to the marketplace.",
  noMatchTitle: "Nothing matches",
  noMatchBody: "No workflow matches the search, status and task type.",
  drawerSubtitle: "You build its graph next",
  create: "Create workflow",
  created: (name: string) => `Created ${name}`,
  nowStatus: (name: string, status: string) => `${name} is now ${status}`,
  deleted: (name: string) => `Deleted ${name}`,
  deleteTitle: (name: string) => `Delete ${name}?`,
  deleteBody: "Deletes the workflow with every version. Refused while a task group uses one of its versions; archive it instead.",
  table: {
    label: "Workflows",
    actionsFor: (name: string) => `Actions for ${name}`,
    workflow: "Workflow",
    taskType: "Task type",
    status: "Status",
    published: "Published",
    draftVersion: (v: number) => `Draft v${v}`,
    updated: "Updated",
  },
};
